// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import {
    MutationCreateContract2FachbereichArgs,
    MutationDeleteContract2FachbereichArgs,
} from '../../../mdqx-graphql-types';
import { Contract2FachbereichEntity } from '../../../entities/mdqx/contract2fachbereich.entity';

export enum Contract2FachbereichActionTypes {
    GetRequest = '[Contract2Fachbereich] Get Request',
    GetResponse = '[Contract2Fachbereich] Get Response',
    PostRequest = '[Contract2Fachbereich] Post Request',
    PostResponse = '[Contract2Fachbereich] Post Response',
    DeleteRequest = '[Contract2Fachbereich] Delete Request',
    DeleteResponse = '[Contract2Fachbereich] Delete Response',
}

export class GetContract2FachbereichRequest implements Action {
    readonly type = Contract2FachbereichActionTypes.GetRequest;
}

export class GetContract2FachbereichResponse implements Action {
    readonly type = Contract2FachbereichActionTypes.GetResponse;
    constructor(public Payload: Contract2FachbereichEntity[]) {}
}

export class PostContract2FachbereichRequest implements Action {
    readonly type = Contract2FachbereichActionTypes.PostRequest;
    constructor(public Payload: MutationCreateContract2FachbereichArgs) {}
}

export class PostContract2FachbereichResponse implements Action {
    readonly type = Contract2FachbereichActionTypes.PostResponse;
    constructor(public Payload: Contract2FachbereichEntity) {}
}

export class DeleteContract2FachbereichRequest implements Action {
    readonly type = Contract2FachbereichActionTypes.DeleteRequest;
    constructor(public Payload: MutationDeleteContract2FachbereichArgs) {}
}

export class DeleteContract2FachbereichResponse implements Action {
    readonly type = Contract2FachbereichActionTypes.DeleteResponse;
    constructor(public Payload: number) {}
}

export type Contract2FachbereichActions =
    | GetContract2FachbereichRequest
    | GetContract2FachbereichResponse
    | PostContract2FachbereichRequest
    | PostContract2FachbereichResponse
    | DeleteContract2FachbereichRequest
    | DeleteContract2FachbereichResponse;
